import { Heading as DSHeading } from '@cinch-labs/design-system'
import { Secondary, Text } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import type { ContentSectionProps as DeliveryOptionCardProps } from '@cinch-nx/landing-ui-shared'
import Image from 'next/legacy/image'

import styles from './delivery-collect.module.css'

export const DeliveryOptionCard: React.FC<DeliveryOptionCardProps> = (blok) => {
  const { _uid, heading, body, image } = blok
  const [CTA] = blok?.CTA || []

  return (
    <section {...storyblokEditable(blok)} key={_uid}>
      {image?.filename ? (
        <div className={styles.imageWrapper}>
          <Image
            src={image.filename}
            alt={image.alt ?? undefined}
            layout="fill"
            objectFit="cover"
          />
        </div>
      ) : null}

      <DSHeading element="h3" className={styles.optionHeading}>
        {heading}
      </DSHeading>

      <Text className={styles.optionBody}>{body}</Text>

      <Secondary
        {...storyblokEditable(CTA)}
        element="a"
        href={CTA.url}
        classNames={{ button: styles.optionButton }}
      >
        {CTA.text}
      </Secondary>
    </section>
  )
}

export default DeliveryOptionCard
